import {
  Dialog,
  DialogContent,
  Slide,
  Box,
  Typography,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { useVisorDocumentosStore } from "hooks/useVisorDocumentosStore";
import { forwardRef } from "react";
import { MenuOptions } from "./components/menuOptions";
import { DocumentPDF } from "./components/documentPDF";
import { FooterOptions } from "./components/footerOptions";
import { DialogCustomTitle } from "components/ui/dialogComponents/dialogCustomTitle";

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const VisorDocumentos = () => {
  const { openVisor, documentoSeleccionado,  openVisorDocumentos, resetAllState, documentSelected } =
    useVisorDocumentosStore();

  return (
    <Dialog
      open={openVisor}
      onClose={() => {
        openVisorDocumentos(false);
        resetAllState();
      }}
      maxWidth="xl"
      fullWidth
      TransitionComponent={Transition}
      keepMounted
      sx={{ height: "100%", width: "100%", }}
      scroll="paper"
    >
      <DialogCustomTitle
        onClose={() => openVisorDocumentos(false)}
        handleClickFunc={() => resetAllState()}
      >
        <Typography variant="h6">Visor Documentos</Typography>
      </DialogCustomTitle>
      <DialogContent>
        <Box
          className="flex justify-center flex-wrap"
          sx={{
            backgroundColor: "#525659",
          }}
        >
          {documentSelected ? (
            <MenuOptions
              documentoSeleccionado={documentoSeleccionado || documentSelected![0]}
            />
          ) : null}
          {documentSelected ? (
            <DocumentPDF blob={documentoSeleccionado || documentSelected![0]} />
          ) : null}
        </Box>
      </DialogContent>
      <FooterOptions />
    </Dialog>
  );
};
